module.exports = __webpack_public_path__ + "static/media/TextIcon.b2557766.svg";